import * as i0 from "@angular/core";
/**
 * Generic "unsaved changes" route guard: it holds no UI of its own, it just asks the
 * component. Which dialog to show, and whether to show one at all, is a decision of
 * the page that owns the pending changes.
 *
 *   { path: 'x', component: XComponent, canDeactivate: [UnsavedChangesGuard] }
 *
 * @since 3.0.0
 */
var UnsavedChangesGuard = /** @class */ (function () {
    function UnsavedChangesGuard() {
    }
    /**
     * Delegate the decision to the component. A component that does not implement the
     * contract never blocks a navigation.
     *
     * @since 3.0.0
     */
    UnsavedChangesGuard.prototype.canDeactivate = function (component) {
        if (!component || typeof component.canDeactivate !== "function") {
            return true;
        }
        return component.canDeactivate();
    };
    UnsavedChangesGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UnsavedChangesGuard_Factory() { return new UnsavedChangesGuard(); }, token: UnsavedChangesGuard, providedIn: "root" });
    return UnsavedChangesGuard;
}());
export { UnsavedChangesGuard };
